import React, { useState } from "react";
import Toggle from "../Toggle";
import PlanToggle from "../PlanToggle";

const ToggleDemo = () => {
  const [alignment, setAlignment] = useState("right");
  const [selectedPlan, setSelectedPlan] = useState("monthly");

  const handleToggle = () => {
    setAlignment((prevAlignment) =>
      prevAlignment === "right" ? "left" : "right"
    );
  };

  const handlePlanToggle = () => {
    setSelectedPlan((prevPlan) =>
      prevPlan === "monthly" ? "annual" : "monthly"
    );
  };

  return (
    <div className="app">
      <h1>Toggle Demo</h1>
      <Toggle onToggle={handleToggle} alignment={alignment} />

      <h1>Plan Toggle Demo</h1>
      <PlanToggle onToggle={handlePlanToggle} selectedPlan={selectedPlan} />
    </div>
  );
};

export default ToggleDemo;
